import map from 'lodash/map';
import Item from 'antd/lib/form/FormItem';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import Select from 'antd/lib/select';

import { RESTRICTED_MARKETPLACES_DATA } from 'components/Settings/dataConstants';
import { notFoundContent, questionMarks } from 'utils/constants/constants';
import { EPoliciesFields } from 'types/settings/enums';

const { Option } = Select;

const TradingPoliciesMarketplaces = () => (
  <>
    <h4 className="mb-4">Restricted Marketplaces</h4>
    <Row gutter={20}>
      <Col span={12}>
        <Item
          label="Restricted Marketplaces"
          name={EPoliciesFields.RestrictedMarketplaceIds}
          tooltip={questionMarks.policies.restrictedMarketplaces}
        >
          <Select
            mode="multiple"
            size="large"
            showArrow
            optionFilterProp="children"
            notFoundContent={notFoundContent}
            placeholder="Enter Restricted Marketplaces"
          >
            {map(RESTRICTED_MARKETPLACES_DATA, ({ id, name }) => <Option key={id} value={id}>{name}</Option>)}
          </Select>
        </Item>
      </Col>
    </Row>
  </>
);

export default TradingPoliciesMarketplaces;
